<div class="row measure-module-selection-container">
  <div class="col-md-12" *ngIf="isEditable">
    <div class="module-selection-field"
         [ngClass]="{
         'short-group': shortModule,
         'medium-group': mediumModule,
         'middle-small-group': middleShortModule,
         'long-group': !shortModule && !mediumModule && !middleShortModule
         }">
      <div class="d-flex flex-row select-module-field-label">
        <span>{{'measure.modules_selected_label' | translate}}:</span>
        <span class="ml-5px">{{selectedModuleName}}</span>
      </div>
      <div class="module-dropdown-container">
        <achoo-filter-box [options]="moduleGroups"
                          [disabled]="shouldDisableFreemiumFeature"
                          (selectEvent)="onSelectGroup($event)"
                          [makeSelectedItemOnTop]="false"
                          [(model)]="selectedGroupId"
                          (openDropDownEvent)="closeTooltip(tg)"
                          #tg="ngbTooltip"
                          placement="bottom"
                          ngbTooltip="{{'info_box.measure.module_selected' | translate}}">
        </achoo-filter-box>
      </div>
    </div>
  </div>
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-12" *ngFor="let module of availableModuleList; let i = index">
        <measure-modules-selection [module]="module"
                                   [index]="i"
                                   [canEditable]="isEditable"
                                   [measureActionContext]="measureContextData('update')"
                                   (activeCallback)="onActivateModule($event)"
                                   (afterDropCallback)="afterDropModule($event)">
        </measure-modules-selection>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-module-dropdown/measure-module-dropdown.component.html